import { LinkBase, Text } from '@belong/ui';
import clsx from 'clsx';
import styles from './market-banner.module.css';
import { PredictiveArc } from './predictive-arc';

const stateConfig = {
  title: 'Rhode Island',
  blogPost:
    '/blog/rhode-island-meet-belong-a-residential-operating-system-for-your-home',
};

export function MarketBanner() {
  return (
    <div
      className={clsx(
        'relative z-50 h-[40px] w-full overflow-hidden',
        styles.banner,
      )}
    >
      <PredictiveArc />
      <div className="relative flex h-full items-center justify-center">
        <LinkBase
          href={stateConfig.blogPost}
          className="gap-x-xs flex flex-wrap items-center"
        >
          <Text className="text-p1 leading-p1 text-white">
            We&apos;ve added <strong>{stateConfig.title}</strong>{' '}
            to&nbsp;Belong!
          </Text>
          <Text
            fontWeight="semibold"
            className="text-p1 leading-p1 text-green hover:text-light-green"
          >
            LEARN MORE
          </Text>
        </LinkBase>
      </div>
    </div>
  );
}
